import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { environment } from "../../environments/environment";
import { GrandTotalReportVM } from "../models/grand-total-report-view-model";
import { HttpClient } from "@angular/common/http";

const URL = environment.apiBaseUrl;

@Injectable()
export class ReportsService {
  constructor(private http: HttpClient) {}

  public getGrandTotalsReport(
    beginQuarter: number,
    endQuarter: number
  ): Observable<GrandTotalReportVM[]> {
    return this.http.get<GrandTotalReportVM[]>(
      `${URL}reports/grandTotalsReport/${beginQuarter}/${endQuarter}`
    );
  }
}
